import Axios from 'axios';
import { ENDPOINTS } from './_config';

export const getFooterItems = async () => {
  try {
    const request = await fetch(ENDPOINTS.FOOTER);
    const response = await request.json();

    localStorage.setItem('footer', JSON.stringify(response));
    localStorage.setItem('footer-time-stamp', Date.now());

    return response;
  } catch (e) {
    return null;
  }
};

export const fetchFooter = async () => {
  try {
    const response = await Axios.get(
      ENDPOINTS.GET_FOOTER
    );
    // response.data will contain the JSON data
    console.log("Footer Data:", response.data);
       console.log('loadMenu2', response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching header menu:", error);
    return null;
  }
};
